import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../../videosAssignmentState/videosAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './CustomerCrumb.module.scss';

const CustomerCrumb: React.FC = () => {
	const { setIDsSelectedCustomers, allCustomers, IDsSelectedCustomers } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const deleteCustomer = (customerID: string) => {
		const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
		delete copyIDsSelectedCustomers[customerID];
		setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
	};

	return (
		<div className={style.container} data-test="CustomerCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="customersLabel"
					size="s"
					weight="bold"
				/>
				<div className={style.selectedItemWrapper}>
					{allCustomers.map((customer) => {
						if (customer.id in IDsSelectedCustomers) {
							return (
								<SelectedItemForBreadcrumbs
									key={customer.id}
									label={customer.name || ''}
									onDelete={() => deleteCustomer(customer.id)}
								/>
							);
						}
					})}
				</div>
			</div>
		</div>
	);
};

export default CustomerCrumb;
